import store from '../redux/store';
import { fetchUser } from '../redux/auth/actions';
import { selectPlatformRoles } from '../redux/auth/selectors';
import { renewSession } from '../service/api';

/**
 * Shown when a support admin invitation was accepted but the session cannot yet prove it.
 * Signing out and in always works: a new sign-in mints a token that is looked up afresh.
 */
export const PLATFORM_ACCESS_PENDING_MESSAGE =
  'Your support access is ready — sign out and in again to open the platform console.';

/**
 * Bring the session up to date after a platform role was granted to the signed-in person.
 *
 * The role is granted in Keycloak, and the server resolves a person's roles per access token,
 * so `fetchUser()` alone can read the profile with the old token and get no platform role
 * back. This renews the token through the app's own refresh flow first (`renewSession`),
 * then re-reads the profile, and answers whether the profile now reports a platform role.
 * `false` means the console would still refuse the person, so they must not be sent there.
 */
export const refreshAfterPlatformGrant = async (
  dispatch: (action: any) => any
): Promise<boolean> => {
  await renewSession();
  await dispatch(fetchUser());
  const roles: string[] = selectPlatformRoles(store.getState());
  return roles.includes('PLATFORM_OWNER') || roles.includes('SUPPORT_ADMIN');
};
